<template>
    <section id="home-feature" class="content-section container px-3">
        <h2 class="content-section-title">PRODUCT OFFERINGS</h2>
        <b-container>
            <b-row class="home-feature-item-wrap">
                <b-col
                    v-for="product in products"
                    :key="product.name"
                    lg="3"
                    class="home-feature-item"
                >
                    <b-img :src="product.src" fliud></b-img>
                    <h3 v-html="product.title"></h3>
                    <router-link class="btn btn-primary btn-sq btn-flat" :to="product.to">explore more</router-link>
                </b-col>
            </b-row>
        </b-container>
    </section>
</template>

<script>
export default {
    data() {
        return {
            products: [
                {
                    src: require('@/assets/images/home/feature_01.jpg'),
                    title: 'CONVENTIONAL<br>WIPER BLADE',
                    to: { name: 'products', hash: '#conventional-wiper-blade'}
                },
                {
                    src: require('@/assets/images/home/feature_02.jpg'),
                    title: 'BEAM<br>WIPER BLADE',
                    to: { name: 'products', hash: '#beam-wiper-blade'}
                },
                {
                    src: require('@/assets/images/home/feature_03.jpg'),
                    title: 'HYBRID<br>WIPER BLADE',
                    to: { name: 'products', hash: '#hybrid-wiper-blade'}
                },
                {
                    src: require('@/assets/images/home/feature_04.jpg'),
                    title: 'HEAVYDUTY<br>WIPER BLADE',
                    to: { name: 'products', hash: '#heavyduty-wiper-blade'}
                },
                {
                    src: require('@/assets/images/home/feature_05.jpg'),
                    title: 'REAR<br>WIPER BLADE',
                    to: { name: 'products', hash: '#rear-wiper-blade'}
                }
            ]
        }
    },
}
</script>

<style lang="scss">
    #home-feature{
        .home-feature-item-wrap {
            justify-content: center;
        }
        .home-feature-item{
            margin-bottom: 50px;
            text-align: center;
            flex: 1 0 20%
        }
        img{
            margin-bottom: 20px;
            max-width: 500px;
            border:1px solid $color-main;
            border-radius: 5px;
        }
        h3{
            margin-bottom: 20px;
            color: $color-main;
            font-size: 1rem !important;
        }

        @media(min-width: 992px) {
            .home-feature-item-wrap {
                flex-wrap: nowrap;
            }
            img{
                max-width: 200px;
            }
        }
    }
</style>